module.exports = __webpack_public_path__ + "img/yjfz-bg.877618eb.png";